import { useEffect, useMemo, useState } from "react";

export const useUpdateEncounter = (paramsToCheck) => {
   const vimOS = window?.vimOS;

   const [canUpdateParams, setCanUpdateParams] = useState(
      paramsToCheck ? vimOS?.ehr?.resourceUpdater?.canUpdateEncounter(paramsToCheck)?.canUpdate : false
   );

   useEffect(() => {
      const cb = () =>
         setCanUpdateParams(
            paramsToCheck ? vimOS?.ehr?.resourceUpdater?.canUpdateEncounter(paramsToCheck)?.canUpdate : false
         );
      vimOS?.ehr?.resourceUpdater?.subscribe("encounter", cb);
      return () => vimOS?.ehr?.resourceUpdater?.unsubscribe("encounter", cb);
   }, [vimOS?.ehr, paramsToCheck]);

   return useMemo(
      () => ({
         canUpdateParams,
         canUpdate: vimOS?.ehr?.resourceUpdater?.canUpdateEncounter,
         updateEncounter: vimOS?.ehr?.resourceUpdater?.updateEncounter,
      }),
      [vimOS?.ehr?.resourceUpdater, canUpdateParams]
   );
};
